import { OrderLimitsSchema } from 'src/models/orderLimits/schema';
import { Left, Right } from 'src/utils/either';
import { shoppingApiBaseUrl } from 'src/utils/shoppingApiBaseUrl';
import { getLocaleFromUrl } from 'src/utils/subdomain';
import { postRequest } from '../wa/gateways/api/wamazingApi';
import { ApiResponse } from './response/ApiResponse';

const orderLimits = async (params: OrderLimitsSchema): Promise<ApiResponse<boolean>> => {
  const response = await postRequest<{
    messages: string[];
  }>({
    baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
    path: '/api/v1/order_limits/check_orderable',
    params: params,
  });
  if (response.messages.length) {
    return new Left({ errors: response.messages });
  }
  return new Right(true);
};

export { orderLimits };
